import { FC } from 'react'
import { Typography, useTheme } from '@mui/material'
import { Table } from '../../../../../components/Table'

const Table_Headers = ['STATE', 'WELL WATER SYSTEM']

const Table_Data = [
  {
    state: 'Alabama',
    wellWaterSystemCount: 53,
  },
]

const headerCells = Table_Headers.map((header, index) => ({
  content: (
    <Typography
      key={index}
      color="secondary"
      fontSize="0.8rem"
    >
      {header}
    </Typography>
  ),
}))

export const WellWaterSystemTable: FC = () => {
  const theme = useTheme()

  const rows: any = Table_Data.map((rowCell) => {
    const cells = [
      {
        content: (
          <Typography
            color="secondary"
            fontSize="0.875rem"
          >
            {rowCell.state}
          </Typography>
        )
      },
      {
        content: (
          <Typography
            color="secondary"
            fontSize="0.875rem"
          >
            {`${rowCell.wellWaterSystemCount} people get well water in this area`}
          </Typography>
        ),
      },
    ]

    return {
      rowProps: {
        sx: { '&:hover': { cursor: 'pointer', background: theme.palette.background.default } },
      },
      cells,
    }
  })

  return (
    <Table
      containerProps={{
        sx: {
          boxShadow: 'none',
          background: 'transparent',
        },
      }}
      head={{
        containerProps: {
          sx: { borderRadius: '8px', background: theme.palette.grey[100], width: '100%' },
        },
        rows: [{ cells: headerCells }],
      }}
      body={{ rows }}
    />
  )
}
